import { ProviderAccountMap } from "./userProviderTenantMapDTO"
export interface UserData {
  firstName: string;
  lastName: string;
  preferredBusinessEmail: string;
  preferredBusinessPhone: string;
  preferredBusinessFax: string;
  phoneNumberExtension: string;
}

export interface CreateUserDTO {
  objectId?: string;
  objectType: DefaultProfileValues.user;
  deletionTimestamp: string;
  accountEnabled: boolean;
  signInNames:
    {
      type: DefaultProfileValues.emailAddress;
      value: string;
    }[];
  assignedLicenses: [];
  assignedPlans: [];
  city: string;
  country: string;
  creationType: DefaultProfileValues.localAccount;
  department: string;
  dirSyncEnabled: string;
  displayName: string;
  facsimileTelephoneNumber: string;
  givenName: string;
  immutableId: string;
  jobTitle: string;
  lastDirSyncTime: string;
  mail: string;
  mailNickname: string;
  mobile: null;
  onPremisesSecurityIdentifier: null;
  otherMails: [];
  passwordPolicies: null;
  physicalDeliveryOfficeName: string;
  postalCode: string;
  preferredLanguage: string;
  provisionedPlans: [];
  provisioningErrors: [];
  proxyAddresses: string[];
  sipProxyAddress: string;
  state: string;
  streetAddress: string;
  surname: string;
  telephoneNumber: string;
  telephoneNumberExtension: string;
  usageLocation: null;
  userType: DefaultProfileValues.member;
  isExternal: boolean;
}

export enum DefaultProfileValues {
    emailAddress = 'emailAddress',
    localAccount = 'LocalAccount',
    member = 'Member',
    user = 'User'
}

export interface RegisterUserWithTenantProvidersMappingDTO {
  userProfile: CreateUserDTO;
  providerMapping: {
    createdBy: string;
    businessTypeId: number;
    providerAccounts: ProviderAccountMap[];
  };
}
